<template>
  <el-select v-model="item.value" v-bind="item.props" v-on="$listeners">
    <template v-if="item.group">
      <el-option-group
        v-for="group in item.options"
        :key="group.label"
        :label="group.label"
      >
        <el-option
          v-for="(opt, index) in group.options"
          :key="index"
          :label="opt.label"
          :value="'value' in opt ? opt.value : opt.label"
          :disabled="opt.disabled">
          <!-- <component :is="getComponent(opt)" v-if="item.scopedSlot"></component> -->
          <slot v-bind="opt"></slot>
        </el-option>
      </el-option-group>
    </template>
    <el-option
      v-else
      v-for="(opt, index) in item.options"
      :key="index"
      :label="opt.label"
      :value="'value' in opt ? opt.value : opt.label"
      :disabled="opt.disabled">
      <!-- <component :is="getComponent(opt)" v-if="item.scopedSlot"></component> -->
      <slot v-bind="opt"></slot>
    </el-option>
  </el-select>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  created () {
    // console.log(this.$slots);
  },
  mounted () {

  },
  watch: {
  },
  methods: {
    // getComponent (opt) {
    //   let vm = this
    //   return {
    //     render (r) {
    //       return r(
    //         'div',
    //         vm.item.scopedSlot(opt)
    //       )
    //     }
    //   }
    // }
  },
  computed: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
</style>
